<template>
    <div v-if="showPreorderInfo" class="pre-order">
        <div class="pick-up-time">
            <span v-if="!isFulfillmentTimeModeEqualTime">{{ trans.orderReceivedPopover.plannedPickUpTime }}: </span>
            <strong>{{ pickupTime }}</strong>
        </div>
    </div>
</template>

<script setup lang="ts">
    import { trans } from "@/app/localization/Trans";
    import { DateTimeUtils } from "@/app/util/DateTimeUtils";
    import { FulfillmentTimeMode } from "@/data/model/Enums";
    import type { IOrderUseCase } from "@/data/model/OrderUseCase";
    import { computed } from "vue";

    const props = defineProps<{
        orderPickUpDateTime: Date | undefined;
        useCase: IOrderUseCase | undefined;
    }>();

    const fulfillmentTimeMode = computed(() => props.useCase?.fulfillmentTimeMode);
    const showPreorderInfo = computed(() => {
        return (
            fulfillmentTimeMode.value != null &&
            fulfillmentTimeMode.value != FulfillmentTimeMode.None &&
            props.orderPickUpDateTime != null
        );
    });
    const isFulfillmentTimeModeEqualTime = computed(() => fulfillmentTimeMode.value == FulfillmentTimeMode.Time);
    const showCirca = computed(() => !isFulfillmentTimeModeEqualTime.value);
    const pickupTime = computed(() =>
        showPreorderInfo.value != null
            ? DateTimeUtils.toDateTimeWithDayOfWeekAndCirca(props.orderPickUpDateTime!, showCirca.value)
            : ""
    );
</script>

<style lang="scss">
    .order-received-popover-content .pre-order {
        margin-top: 6px;

        .pick-up-time {
            text-align: center;
            font-size: 14px;
        }
    }
</style>
